<script setup>
import { onMounted } from 'vue';
import { RouterView } from 'vue-router';
import Sidebar from '@/components/Sidebar.vue';
import TopBar from '@/components/TopBar.vue';
import { useAuthStore } from '@/stores/auth.js';

const auth = useAuthStore();

// Refresh /me on first mount so a stale localStorage user gets reconciled.
onMounted(() => {
  if (auth.token) auth.refreshMe();
});
</script>

<template>
  <div class="min-h-screen flex bg-(--admin-canvas)">
    <Sidebar />
    <div class="flex-1 flex flex-col min-w-0">
      <TopBar />
      <main class="flex-1 px-4 sm:px-8 py-7 max-w-[1400px] w-full mx-auto">
        <RouterView />
      </main>
    </div>
  </div>
</template>
